import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { memo, useCallback, useMemo, useState } from 'react';
import { ModalWrapperCloseIcon, useAnalytics, useImageBlob, useResponsiveBreakPoints } from '@restworld/utils-common';
import { LocaleItem, NavLabelItem } from './mobile-overlay-nav';
import { useSpringRef, useTransition, useChain } from '@react-spring/web';
import { Button, Title, BaseModal, ButtonV2 } from '../../../';
import HamburgerComponent from './hamburger-component';
import { Avatar } from 'flowbite-react';
import { useTranslation } from 'next-i18next';
import Router from 'next/router';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var DesktopOverlayNav = /*#__PURE__*/memo(function (props) {
  var _props$background = props.background,
      background = _props$background === void 0 ? 'white' : _props$background,
      isAuthenticated = props.isAuthenticated,
      avatarName = props.avatarName,
      avatarImage = props.avatarImage,
      isNavOverlay = props.isNavOverlay,
      navOverlayToggler = props.navOverlayToggler,
      onStartLogin = props.onStartLogin,
      onStartSignup = props.onStartSignup,
      onLogout = props.onLogout,
      isAmbassador = props.isAmbassador,
      primaryItems = props.primaryItems,
      localeComponent = props.localeComponent,
      testId = props.testId;

  var _useState = useState(),
      activeItem = _useState[0],
      setActiveItem = _useState[1];

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useAnalytics = useAnalytics(),
      trackEvent = _useAnalytics.trackEvent;

  var isSubItemAvailable = useMemo(function () {
    return Boolean(activeItem === null || activeItem === void 0 ? void 0 : activeItem.subItems.length);
  }, [activeItem === null || activeItem === void 0 ? void 0 : activeItem.subItems.length]);
  var frontNavItems = useMemo(function () {
    if (activeItem !== null && activeItem !== void 0 && activeItem.subItems) return activeItem === null || activeItem === void 0 ? void 0 : activeItem.subItems;
    return primaryItems;
  }, [activeItem === null || activeItem === void 0 ? void 0 : activeItem.subItems, primaryItems]);
  var onSelectActiveItem = useCallback(function (value) {
    return setActiveItem(value);
  }, []);
  var onClickMenuToggler = useCallback(function () {
    navOverlayToggler(function (prev) {
      return !prev;
    });
    onSelectActiveItem();
  }, [navOverlayToggler, onSelectActiveItem]);
  var navRef = useSpringRef();
  var liRef = useSpringRef();
  var subRef = useSpringRef();

  var _useTransition = useTransition(isNavOverlay && !(activeItem !== null && activeItem !== void 0 && activeItem.subItems) ? frontNavItems : [], function () {
    return {
      ref: liRef,
      trail: 400 / frontNavItems.length,
      from: {
        opacity: 0,
        transform: 'translateY(20px)'
      },
      enter: {
        opacity: 1,
        transform: 'translateY(0)'
      },
      leave: {
        opacity: 0,
        transform: 'translateY(20px)'
      }
    };
  }),
      _useTransition2 = _slicedToArray(_useTransition, 1),
      primaryTransitions = _useTransition2[0];

  var _useTransition3 = useTransition((activeItem === null || activeItem === void 0 ? void 0 : activeItem.subItems) || [], function () {
    return {
      ref: subRef,
      trail: 500 / frontNavItems.length,
      from: {
        opacity: 0,
        transform: 'translateY(20px)'
      },
      enter: {
        opacity: 1,
        transform: 'translateY(0)'
      },
      leave: {
        opacity: 0,
        transform: 'translateY(20px)'
      }
    };
  }),
      _useTransition4 = _slicedToArray(_useTransition3, 1),
      subItemTransitions = _useTransition4[0]; // On showMenu, start with nav animation, then nav items


  useChain(isNavOverlay ? [navRef, liRef] : [liRef, navRef], [0, isNavOverlay ? 0.4 : 0.6]); // When sub-items are shown, close liRef and open subRef

  useChain(activeItem !== null && activeItem !== void 0 && activeItem.subItems ? [liRef, subRef] : [subRef, liRef], [0, activeItem !== null && activeItem !== void 0 && activeItem.subItems ? 0.4 : 0.6]);
  var avatarImageURL = useImageBlob(avatarImage);
  if (!isDesktop) return null;
  var footer = isAuthenticated && !isSubItemAvailable ? /*#__PURE__*/_jsx(_StyledDiv, {
    children: /*#__PURE__*/_jsx(Button, {
      title: t('common:exit'),
      icon: "ArrowRightOnRectangleBlackIcon",
      variant: "secondary-outline",
      onClick: onLogout,
      fullwidth: true,
      "data-cy": "logout-button-desktop"
    })
  }) : undefined;

  var ModalExitIcon = /*#__PURE__*/_jsx(_StyledSpan, {
    children: /*#__PURE__*/_jsx(ModalWrapperCloseIcon, {})
  });

  var gettingStartedButton = !isAuthenticated && /*#__PURE__*/_jsx(ButtonV2, {
    variant: "secondary-restworld",
    size: "sm",
    twStyle: {
      "marginLeft": "2rem",
      "marginRight": "2rem",
      "marginTop": "1rem",
      "maxWidth": "20rem"
    },
    onClick: function onClick() {
      return Router.push('/getting-started?utm_source=map');
    },
    fullwidth: true,
    children: /*#__PURE__*/_jsx(_StyledH, {
      children: t('common:publish_your_venue_for_free')
    })
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_StyledDiv2, {
      children: /*#__PURE__*/_jsxs(_StyledDiv3, {
        onClick: function onClick() {
          onClickMenuToggler();
        },
        children: [isAuthenticated ? /*#__PURE__*/_jsx(_StyledAvatar, {
          size: "sm",
          alt: "avatar-img",
          rounded: true,
          color: "purple",
          img: avatarImageURL
        }) : null, /*#__PURE__*/_jsx(HamburgerComponent, {
          background: background,
          isOpen: isNavOverlay
        })]
      })
    }), /*#__PURE__*/_jsx(BaseModal, {
      open: isNavOverlay,
      onClose: function onClose() {
        return onClickMenuToggler();
      },
      variant: "right",
      noPadding: true,
      hideHeader: isSubItemAvailable,
      footer: footer,
      closeIcon: ModalExitIcon,
      children: /*#__PURE__*/_jsxs(_StyledDiv4, {
        "data-cy": testId,
        children: [/*#__PURE__*/_jsxs(TopItem, {
          isHeader: isSubItemAvailable,
          children: [isSubItemAvailable ? /*#__PURE__*/_jsx(Button, {
            variant: "ghost",
            onClick: function onClick() {
              return onSelectActiveItem();
            },
            children: /*#__PURE__*/_jsx(Title, {
              textColor: "black",
              content: t('common:back'),
              icon: "ArrowLeftIcon",
              fontWeight: "semibold",
              twStyle: {
                "textDecorationLine": "underline",
                "textUnderlineOffset": "2px",
                "@media (min-width: 1024px)": {
                  "fontSize": "0.875rem",
                  "lineHeight": "1.25rem"
                }
              }
            })
          }) : null, !isSubItemAvailable && /*#__PURE__*/_jsxs(Title, {
            variant: "h2-medium",
            fontWeight: "semibold",
            children: ["Ciao", isAuthenticated && avatarName ? " ".concat(avatarName) : '', "!", ' ', !isAuthenticated && /*#__PURE__*/_jsx("span", {
              role: "img",
              "aria-labelledby": "ciao",
              children: "\uD83D\uDC4B\uD83C\uDFFB"
            })]
          })]
        }), (activeItem === null || activeItem === void 0 ? void 0 : activeItem.id) !== 'who-we-are' && gettingStartedButton, /*#__PURE__*/_jsxs(_StyledDiv5, {
          children: [activeItem !== null && activeItem !== void 0 && activeItem.label ? /*#__PURE__*/_jsx(_StyledDiv6, {
            children: /*#__PURE__*/_jsx(Title, {
              fontWeight: "semibold",
              textColor: "primary-700",
              twStyle: {
                "fontSize": "1.125rem",
                "lineHeight": "1.688rem",
                "@media (min-width: 1024px)": {
                  "fontSize": "1.125rem",
                  "lineHeight": "1.688rem"
                }
              },
              fontSize: "large",
              content: activeItem === null || activeItem === void 0 ? void 0 : activeItem.label
            })
          }) : null, // If there are no sub-items, show primary items
          !(activeItem !== null && activeItem !== void 0 && activeItem.subItems) ? /*#__PURE__*/_jsx(NavLabelItem, {
            onSelectActiveItem: onSelectActiveItem,
            frontNavItems: frontNavItems,
            avatarName: avatarName,
            activeItem: activeItem,
            transitions: primaryTransitions,
            isPrimary: true
          }) : null, // If there are sub-items, show sub-items
          activeItem !== null && activeItem !== void 0 && activeItem.subItems ? /*#__PURE__*/_jsx(NavLabelItem, {
            onSelectActiveItem: onSelectActiveItem,
            frontNavItems: frontNavItems,
            avatarName: avatarName,
            activeItem: activeItem,
            transitions: subItemTransitions
          }) : null, (activeItem === null || activeItem === void 0 ? void 0 : activeItem.id) === 'who-we-are' && gettingStartedButton, isSubItemAvailable ? null : localeComponent ? /*#__PURE__*/_jsx(LocaleItem, {
            localeComponent: localeComponent
          }) : null, !isSubItemAvailable && !isAuthenticated && !isAmbassador ? /*#__PURE__*/_jsxs(_StyledDiv7, {
            children: [/*#__PURE__*/_jsx(Button, {
              "data-cy": "login-button-desktop",
              fullwidth: true,
              variant: "normal",
              title: t('common:login'),
              onClick: function onClick() {
                onStartLogin();
                trackEvent('initiate_signin', {
                  login_state: false,
                  user_type: null
                });
              }
            }), /*#__PURE__*/_jsx(Button, {
              fullwidth: true,
              variant: "secondary-outline",
              title: t('common:create_account'),
              onClick: function onClick() {
                onStartSignup(); // trackEvent('initiate_create_account', {
                //   origin: 'sidebar',
                // });
              }
            })]
          }) : null]
        })]
      })
    })]
  });
});
export var TopItem = /*#__PURE__*/_styled.div.withConfig({
  displayName: "desktop-overlay-nav__TopItem",
  componentId: "sc-1xhb68c-0"
})(["", " ", ""], {
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "borderBottomWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "paddingLeft": "46px",
  "paddingRight": "2rem"
}, function (_ref) {
  var isHeader = _ref.isHeader;
  return isHeader ? {
    "paddingTop": "3rem"
  } : {};
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-overlay-nav___StyledDiv",
  componentId: "sc-1xhb68c-1"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "alignItems": "center",
  "paddingLeft": "2rem",
  "paddingRight": "2rem",
  "paddingTop": "1.5rem"
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "desktop-overlay-nav___StyledSpan",
  componentId: "sc-1xhb68c-2"
})({
  "display": "inline-flex",
  "width": "fit-content",
  "paddingLeft": "0.875rem"
});

var _StyledH = /*#__PURE__*/_styled("h5").withConfig({
  displayName: "desktop-overlay-nav___StyledH",
  componentId: "sc-1xhb68c-3"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(72 36 133 / var(--tw-text-opacity))"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-overlay-nav___StyledDiv2",
  componentId: "sc-1xhb68c-4"
})({
  "display": "flex",
  "width": "fit-content",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.25rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-overlay-nav___StyledDiv3",
  componentId: "sc-1xhb68c-5"
})({
  "display": "flex",
  "width": "fit-content",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});

var _StyledAvatar = /*#__PURE__*/_styled(Avatar).withConfig({
  displayName: "desktop-overlay-nav___StyledAvatar",
  componentId: "sc-1xhb68c-6"
})({
  "minWidth": "32px",
  ":hover": {
    "cursor": "pointer"
  }
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-overlay-nav___StyledDiv4",
  componentId: "sc-1xhb68c-7"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.5rem"
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-overlay-nav___StyledDiv5",
  componentId: "sc-1xhb68c-8"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "1rem",
  "paddingLeft": "2rem",
  "paddingRight": "2rem"
});

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-overlay-nav___StyledDiv6",
  componentId: "sc-1xhb68c-9"
})({
  "padding": "0.875rem"
});

var _StyledDiv7 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-overlay-nav___StyledDiv7",
  componentId: "sc-1xhb68c-10"
})({
  "marginTop": "1.5rem",
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.5rem"
});